module.exports = require("./yo-BJ.d.ts");